import parse from 'html-react-parser';
import type { ReactElement } from 'react';
import Mustache from 'mustache';
import proxyData from 'mustache-validator';

import { UserDynamicValues } from 'types/user';

const validateVariableData = (
  data: any // eslint-disable-line
) =>
  proxyData(data, {
    handleError: (invalidPropertyPathSegments) => {
      // eslint-disable-next-line no-console
      console.warn(`Variable ${invalidPropertyPathSegments.join('.')} missing`);
    },
  });

export function contentWithData(
  content: string,
  state: UserDynamicValues
): Array<ReactElement> | ReactElement | string {
  return parse(Mustache.render(content, validateVariableData(state)));
}

export function contentWithExternalData(
  content: string,
  data: any // eslint-disable-line
): Array<ReactElement> | ReactElement | string {
  return parse(Mustache.render(content, validateVariableData(data)));
}
